import React, { Component } from "react";
import { toast } from "react-toastify";
import * as yup from "yup";
import { ErrorMessage } from "components/shared/ErrorMessage";
import _ from "lodash";
import switchService from "services/admin/masters/switchService";
import Spinner from "components/shared/Spinner"; 
import { MSG_CREATE_RECORD, MSG_UPDATE_RECORD, TEXT_MIN_LENGTH, TEXT_MAX_LENGTH } from "constants/admin/masters/switch";
import { handleChange, handleTouched,formFailure,getCurrentSlug,trimFields } from "utils/masterHelpers";
import Breadcrumb from "components/shared/Breadcrumb";
const serviceObj = new switchService();
class Form extends Component {
  constructor(props) {
    super(props);
    this.handleChange=handleChange.bind(this);
    this.handleTouched=handleTouched.bind(this);
    this.formFailure=formFailure.bind(this);
    this.getCurrentSlug=getCurrentSlug.bind(this);
    this.trimFields=trimFields.bind(this);
    this.state = {
      isEditForm: false,
      Id: 0,
      formReady: false,
      isSubmitting: false,
      errors: {},
      touched: {},
      form: {
        name: "",
        switch_vendor_id: 0,
      },
      switchVendors: [],
      breadcrumbs:[{ title: 'Switch Firmware Series List', url: '/admin/master/'+this.getCurrentSlug() },
                   { title: 'Switch Firmware Series' }
                  ]
    };
  }

  componentDidMount = async () => {
    const { Id } = this.props.match.params;
    await serviceObj.getAllVendorDropdown().then((response) => {
      this.setState({
        switchVendors: response,
      });
    });
    if (Id > 0) {
      //repopulate the form
      this.setState({
        Id,
        isEditForm: true,
      });
      const Info = await serviceObj.firmwareSeriesDetail(Id);
      const form = this.state.form;
      form.name = Info.name;
      form.switch_vendor_id = Info.switch_vendor_id;
      this.setState(
        {
          form,
        },
        () => {
          this.setState({
            formReady: true,
          });
        }
      ); //populate in form
    } else {
      //do any preload any api call if needed in caseof add form then make the form ready to load
      this.setState({
        formReady: true,
      });
    }
  }; 

  submitForm = async (e) => {
    e.preventDefault();
    this.trimFields(this.state.form);
    this.setState({
      isSubmitting: true,
    });
    const errors = await this.validateForm();
    if (_.isEmpty(errors)) {
      //now proceed to save user
      const form = this.state.form;
      try {
        let response;
        if (this.state.Id > 0 && this.state.isEditForm) {
          response = await serviceObj.updateFirmwareSeries(form, this.state.Id);
        } else {
          response = await serviceObj.createFirmwareSeries(form);
        }
        if (response) {
          toast.success(response.message || (this.state.isEditForm) ? MSG_UPDATE_RECORD : MSG_CREATE_RECORD);
          this.props.history.push("/admin/master/"+this.getCurrentSlug());
        }
      } catch (err) {
        //failure case
        this.formFailure();
        if (err) {
          const errors = this.state.errors;
          for (const [field, msg] of Object.entries(err)) {
            errors[field] = msg[0];
          }
          await this.setState({
            errors,
          });
        }
      }
    } else {
      //failure case
      this.formFailure();
    }
  }; 

  validateForm = async () => {
    const errors = {};
    const schema = yup.object().shape({
      name: yup.string().required().min(TEXT_MIN_LENGTH).max(TEXT_MAX_LENGTH),
      switch_vendor_id: yup.number().required().positive('please select a switch vendor.'),
    });
    // check validity
    await schema
      .validate(this.state.form, { abortEarly: false })
      .catch(function (err) {
        err.inner.map((error) =>
          !errors[error.path] ? (errors[error.path] = error.message) : null
        );
      });

    this.setState({
      errors,
    });
    return errors; //return basicerrors
  };

  render() {
    const {
      isSubmitting,
      form,
      touched,
      errors,
      isEditForm,
      formReady,
      switchVendors,
      breadcrumbs
    } = this.state;
    return (
      <div className="form-wrap mt-3">
        {isSubmitting ? <Spinner /> : null}
        {formReady ? (
          <div className="form-group">
            <Breadcrumb data={breadcrumbs} isEdit={isEditForm} />
            <form onSubmit={this.submitForm}>

              <div className="form-group">
                <label htmlFor="switch_vendor_id">Switch Vendor</label>
                <select
                  name="switch_vendor_id"
                  onChange={this.handleChange}
                  disabled={isEditForm}
                  value={form.switch_vendor_id}
                  className={`form-control ${
                    touched.switch_vendor_id && errors.switch_vendor_id
                      ? "is-invalid"
                      : ""
                    }`}
                >
                  <option key="-1" value="0">
                    --SELECT--
                  </option>
                  {switchVendors.length
                    ? switchVendors.map((vendor, index) => (
                      <option key={index} value={vendor.id}>
                        {vendor.name}
                      </option>
                    ))
                    : null}
                </select>
                <ErrorMessage
                  tag="div"
                  touched={touched}
                  errors={errors}
                  name="switch_vendor_id"
                  className="text-danger"
                />
              </div>

              <div className="form-group">
                <label htmlFor="name">
                  Firmware Series Name
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter firmware series name"
                  onChange={this.handleChange}
                  value={form.name}
                  className={`form-control ${
                    touched.name && errors.name
                      ? "is-invalid"
                      : ""
                    }`}
                />
                <ErrorMessage
                  tag="div"
                  touched={touched}
                  errors={errors}
                  name="name"
                  className="text-danger"
                />
              </div>
              <button
                type="submit"
                className="btn btn-secondary btn-block"
                disabled={isSubmitting}
              >
                {isSubmitting
                  ? "Please wait..."
                  : isEditForm
                    ? "Update"
                    : "Add"}
              </button>
            </form>
          </div>
        ) : (
            <Spinner />
          )}
      </div>
    );
  }
}

export default Form;
